<div [blazeSlotNode]="slots?.slotNodesData?.header">
  <ng-container *ngTemplateOutlet="slots?.templates?.header || null" />
</div>
<div [blazeSlotNode]="slots?.slotNodesData?.main">
  <ng-container *ngTemplateOutlet="slots?.templates?.main || null" />
</div>
